// tslint:disable-next-line no-any
export function noop(...args: any[]): void {
  // noop
}
